<template>
  <div class="pest-faq-section">
    <div class="flex-h-center">
      <div class="slash header mr10"></div>
      <div class="header-title purple-2">热门问题</div>
      <div class="slash header ml10"></div>
    </div>
    <div class="faq-cell-wrapper mt30" v-if="$route.params.id == item.id" v-for="(item, index) in list" :key="index">
      <div class="faq-cell" @click="getHotQuesion($event)" v-for="(titem, tindex) in item.questions" :key="tindex" :id="'hotquestion_div_getHotQuesion_'+tindex">
        <div :data-fuget="titem.fuget_id" class="faq-cell-header flex-row">
          <img class="icon" src="@/assets/img/resources/plus-w-bold.svg"/>
          <img style="display: none" class="icon" src="@/assets/img/resources/icon-minus-pink.svg"/>
          <div class="faq-cell-question">{{titem.question}}</div>
        </div>
        <div class="faq-cell-answer"><p style="line-height: 32px;">
          <template v-for="(nitem, nindex) in titem.answer">
            {{nitem}}<br v-if="nindex != titem.answer.length-1">
          </template>
          <template v-if="titem.answer_list">
            <br>
            {{titem.answer_list.title}}<br>
            <template v-for="(citem, cindex) in titem.answer_list.list">
              {{cindex + 1}}.{{citem}}<br v-if="citem != titem.answer_list.list.length-1">
            </template>
          </template>
        </p>
          <div class="cell-img-wrapper flex-row" style="margin-top: 16px;">
            <img v-for="(xitem, xindex) in titem.img_list" :key="xindex"  v-lazy="require('@/assets/img/resources/uploads/' + xitem)" class="pic mr10">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '@/styles/pest_wiki/global2.less';
  import '@/styles/pest_wiki/pest_wiki_detail.less';
  export default {
    name: "hot_question",
    data() {
      return {
        list: [
          {
            id: 2,
            questions: [
              {
                question: '我家里很干净，为什么还是有蟑螂？',
                answer: ['做好清洁卫生确实可以很大程度上减少蟑螂滋生的可能性。但蟑螂入侵途径多样，人们很难真正阻绝它进入室内。譬如快递纸盒，小强或许就躲藏在纸盒的纸楞里偷渡进家中。此外，蟑螂的生命力十分旺盛，一丁点的食物碎屑就可以够一只蟑螂生活个把月。因此除了定期的清洁打扫，食物的密封保存、杂物的定期处理以及有效的预防处理互相搭配才能真正控制蟑螂。'],
                fuget_id: '303',
                img_list: ['notitle-1-3.jpg']
              },
              {
                question: '传说中“看到一只小强，说明家里还有上万只它的同伴”是真的吗？',
                answer: ['上万只的说法是较为夸张的说法，该数字据推断应演绎自国外一关于德国小蠊繁殖情况的研究，该研究表示“理想状态下，一对德国小蠊可以繁衍出&gt;10000只后代”但实际情况中，受食源、温度、场所等环境因素的影响，一般家庭并不会到达如此夸张的数字。但毋庸置疑的是蟑螂的繁殖力十分惊人，如果看到了一只小强，那有许多它的同伴躲在暗处的概率还是很大的。'],
                fuget_id: '304',
                img_list: []
              },
              {
                question: '用气雾罐狂喷蟑螂，但它好像完好无损不为所动？',
                answer: ['最新的科学研究显示，越来越多的蟑螂开始对多种杀虫剂产生抗性，其中菊酯类的杀虫剂最为明显。大部分的气雾罐都以拟除虫菊酯作为有效成分，这或是其中部分原因。此外，在使用气雾罐灭蟑时，一定要注意及时将处理掉的蟑螂清除出室外，否则可能出现蟑螂没有死透或是德国小蠊随身携带的卵鞘应激孵化，扩散到房间的其他角落。'],
                fuget_id: '305',
                img_list: []
              },
            ]
          },
          {
            id: 3,
            questions: [
              {
                question: '白蚁是蚂蚁的一种吗？两者有什么区别？',
                answer: ['很多人会把白蚁和蚂蚁混淆在一起，以为会飞的蚂蚁就是白蚁，甚至直呼白蚂蚁或飞蚂蚁，这其实是错误的。白蚁属于蜚蠊目（等翅目），从分类上看反倒和蟑螂是近亲，而蚂蚁属于膜翅目，细腰亚目。'],
                fuget_id: '315',
                img_list: ['1.jpg', '2.jpg'],
                answer_list: {
                  title: '白蚁和蚂蚁外形上最大的区别有三点：',
                  list: [
                    '触角不同。白蚁的触角为念珠状，蚂蚁的触角为膝装。',
                    '翅膀不同。白蚁的四个翅膀大小均等，而有翅蚂蚁前后翅大小不同。',
                    '腰部不同。白蚁胸腹间交接部分宽度变化不大，而蚂蚁胸腹间有明显细腰节。'
                  ]
                }
              },
              {
                question: '家里为什么会有白蚁？',
                answer: [
                  '白蚁喜温湿，我国南方地区多降水，春夏温度渐高，白蚁容易滋生。此外，白蚁食性广，以植物性纤维素及其制品为主食，家中的木质结构或家具是它们的理想藏身处和食源。家中比较潮湿，或有漏水现象，则更容易成为白蚁的入侵对象。',
                  '白蚁主要通过修筑蚁道和婚飞侵入家中。每年3~6月是白蚁的婚飞季，大量的白蚁倾巢而出进行婚配，此时它们很容易被室内灯光吸引飞入家中并新建“王朝”。'
                ],
                fuget_id: '316',
                img_list: []
              },
              {
                question: '家住高楼是不是就不用担心白蚁问题了？',
                answer: [
                  '毋庸置疑，楼层较矮的住房受白蚁入侵风险更大，尤其是散白蚁。但高楼也不能掉以轻心。每年3-6月是白蚁的分飞（婚飞）季，以台湾乳白蚁为代表的婚飞蚁可以飞上30多层高楼新建巢穴。此外，家中的一些木制家具，若没经过严格的源头材质把控，也可能携带白蚁。'
                ],
                fuget_id: '317',
                img_list: []
              },
              {
                question: '家里发现白蚁该怎么办？可以自己处理吗？',
                answer: [
                  '白蚁是社会性昆虫，尤其是乳白蚁，往往种族庞大，而且有多个隐匿藏身处，处理难度较大。',
                  '有些消费者见到白蚁可能会采取一些想当然的自救措施，如用喷雾罐喷，这种手法其实是错误的。多数家用喷雾罐有效成分为拟除虫菊酯，这对白蚁治理来说并非好的选择。一方面拟除虫菊酯滞留性较差，只能处理到局部或表面，无法根治。另一方面它有趋避性，容易惊吓到白蚁使其逃散，反而影响治理效果。',
                  '市面上的白蚁药参差不齐，甚至有些国外已禁用的高毒性药剂仍在国内流通。与此同时，好的药剂需搭配专业的设备和处理，才能达到理想的效果，因此建议消费者选择专业团队进行治理。'
                ],
                fuget_id: '318',
                img_list: []
              },
            ]
          },
          {
            id: 4,
            questions: [
              {
                question: '为什么老鼠会进入室内？',
                answer: [
                  '一般室内环境优渥，对老鼠来说有着丰富的食源和栖息场所，容易吸引老鼠进入。如果房屋建筑上存在缺陷漏洞、或有出入口长时间敞开，都可能为老鼠提供可乘之机。要知道，小家鼠可以钻过6mm的孔洞。此外老鼠活动能力强，而且十分聪明，有着敏锐的嗅觉、味觉和听觉，能够在建筑中迅速找到入侵通道。'
                ],
                fuget_id: '329',
                img_list: ['2-2.jpg']
              },
              {
                question: '新建小区/高楼会有老鼠问题吗？',
                answer: ['老鼠问题不单单是卫生的问题，它与房屋建筑结构也息息相关。不管是老小区还是新小区，低层还是高楼，都有可能遭到老鼠入侵。一些建筑在建造过程中忽略了这一点，尤其是一些高楼建筑，线路管道复杂但又没有做好封堵，使得老鼠可以在大楼之中肆意穿梭。我们服务过非常多的高楼用户，其中不乏一些知名高档小区。'],
                fuget_id: '330',
                img_list: ['1-2.jpg']
              },
              {
                question: '老鼠怕什么？',
                answer: ['老鼠常见的天敌有猫、蛇，以及人。按以往经验，家中养猫的人家，一般不太会有什么老鼠问题，但现在越来越多的宠物猫似乎也在逐渐丧失捉老鼠的天性和能力。美国芝加哥曾尝试通过引进猫咪来控制城市鼠患，但收效甚微。网络上流行的老鼠怕超声波以及市面上的一些超声波除鼠仪都已被科学检验没有效用。真正有效的老鼠防治还得人们根据其习性综合使用陷阱、诱捕、毒杀以及关键的封堵等多种手段。'],
                fuget_id: '331',
                img_list: []
              },
            ]
          },
          {
            id: 5,
            questions: [
              {
                question: '蚂蚁咬人吗？',
                answer: ['蚂蚁在感受到威胁或遭到攻击时会用两个大牙叮咬的方式进行攻击或自卫，咬时会分泌出蚁酸（甲酸），刺激被叮咬的伤口红肿疼痛。部分种类腹部末端具有螫针。'],
                fuget_id: '345',
                img_list: ['2-7.jpg']
              },
              {
                question: '蚂蚁会飞吗？和白蚁有什么不同？',
                answer: ['蚂蚁一般都没有翅膀，但雄蚁和处女雌蚁在交配时有翅膀，雄蚁交配后翅膀即脱落，雄蚁交配后会死亡。很多人会把白蚁和蚂蚁混淆在一起，以为会飞的蚂蚁就是白蚁，甚至直呼白蚂蚁或飞蚂蚁，这其实是错误的。白蚁属于蜚蠊目（等翅目），从分类上看反倒和蟑螂是近亲，而蚂蚁属于膜翅目，细腰亚目。'],
                fuget_id: '346',
                img_list: ['1-7.jpg', '3-4.jpg'],
                answer_list: {
                  title: '白蚁和蚂蚁外形上最大的区别有三点：',
                  list: [
                    '触角不同。白蚁的触角为念珠状，蚂蚁的触角为膝装。',
                    '翅膀不同。白蚁的四个翅膀大小均等，而有翅蚂蚁前后翅大小不同。',
                    '腰部不同。白蚁胸腹间交接部分宽度变化不大，而蚂蚁胸腹间有明显细腰节。'
                  ]
                }
              },
              {
                question: '我买了专门灭蚂蚁的胶饵，但点了没什么用，这是为什么？',
                answer: ['一种原因是胶饵点的不到位，通常胶饵点施的位置应处于蚂蚁的活动路径上，如能找到蚂蚁的巢穴则效果更佳。此外，大部分的蚂蚁都喜食甜食，因此大多数蚂蚁胶饵都会将葡萄糖作为引诱剂吸引蚂蚁前来取食。但有一些蚂蚁是肉食性或偏肉食性的，如大头蚁，此时胶饵对它的吸引力可能就会减弱。'],
                fuget_id: '347',
                img_list: []
              }
            ]
          },
          {
            id: 6,
            questions: [
              {
                question: '宠物定期驱虫/家里没养宠物，为什么还是会有跳蚤？',
                answer: ['由于跳蚤无特定的宿主，在各种有毛的动物身上均可寄生，即使对宠物定期驱虫，但仍有可能跳蚤通过其他动物，如随老鼠、流浪猫狗（为躲避酷暑或严寒）进室内。此外，跳蚤也会在布料、地毯上产卵。虫卵有卵壳保护，可以存活较长一段时间，待孵化后再伺机回到动物身上寄生。所以，只控制宠物身上的跳蚤无法完全杜绝跳蚤，环境本身还潜藏了其他的跳蚤隐患。'],
                fuget_id: '358',
                img_list: []
              },
              {
                question: '怎么判断是被跳蚤咬的？',
                answer: ['最常被跳蚤咬的位置是腿部靠近脚踝位置。跳蚤叮咬后会引起局部组织的变态反应，产生大小不同的丘疹，显露的症状是呈现红斑，且被红色晕圈包围。被咬处通常奇痒难忍，对人造成极大的不适。它们非常痒，引起很大的不适。宠物被跳蚤咬，同样身上会起很多红疹，宠物会不自觉地抓挠自己，严重的可能还会引起无精打采、贫血等症状。'],
                fuget_id: '359',
                img_list: []
              },
              {
                question: '被跳蚤咬了怎么办？',
                answer: ['被跳蚤咬后，应及时清洗被咬伤口，用冰袋冷敷，并及时就医，向医生咨询适合的药物，如抗组胺药。宠物身上发现跳蚤的话应尽快带到宠物医院进行全身清洁，并进行科学除虫。以上完成后更为妥帖的办法是请专业虫控人员上门对家中环境进行灭治处理，以绝后患。'],
                fuget_id: '360',
                img_list: []
              }
            ]
          },
          {
            id: 7,
            questions: [
              {
                question: '我非常注意卫生清洁，为什么家里还有很多苍蝇？',
                answer: ['首先可以检查一下房屋是否有明显的漏洞或入口可供苍蝇进来，如窗户未装纱窗或纱窗网格过大，无法有效阻拦苍蝇，而刚好房屋附近有适合苍蝇滋生的环境，如餐馆、水沟、下水道等。另外还需排查是否有老鼠、鸟类、流浪猫狗等闯入家中，死在阁楼、天花板夹层等隐蔽的地方，其尸体腐烂时也会吸引苍蝇过来。'],
                fuget_id: '373',
                img_list: []
              },
              {
                question: '苍蝇为什么老搓脚？',
                answer: ['苍蝇搓脚是在清洁身体除此以外它还喜欢后腿互蹬，用手刮脑袋。此外苍蝇搓脚还可以保持飞行、爬行和味觉的灵敏性。虽然干净了自己，但由于苍蝇平时接触的尽是粪便、污水等脏东西，当它再次接触食物时很容易借此传播病菌。另外，苍蝇还有边吃边拉的习惯，会将肠子里的一些病菌、寄生虫卵等都排在食物上，危害人们健康。'],
                fuget_id: '374',
                img_list: ['02.jpg']
              },
              {
                question: '吃了被苍蝇叮过的食物/不小心吃下一只苍蝇怎么办？',
                answer: ['虽然苍蝇携带病菌，但一般来说，偶发的这种情况传播的细菌数量还是有限的，不太会真的致使人患病，更多的是给人带来恶心的心理负担。但如果遇到了此类问题，应该尽快将苍蝇问题解决，以免类似情况再次发生。'],
                fuget_id: '375',
                img_list: []
              }
            ]
          },
          {
            id: 8,
            questions: [
              {
                question: '蚊子老是叮我，是因为我是O型血吗？',
                answer: ['蚊子吸血跟血型没有直接关联。蚊子对血型并不挑食，加州理工学院研究发现，蚊子“捕猎”，靠的是二氧化碳、温度、气味和视觉。运动过后满身是汗的时候，或者比较胖的人群比较容易受到蚊子的青睐。穿深色服装也更容易吸引蚊子，橘红色则是他们讨厌的颜色。'],
                fuget_id: '',
                img_list: ['notitle-1-2.jpg']
              },
              {
                question: '蚊子怕什么，维生素B可以驱蚊吗？怎么不被蚊子咬？',
                answer: ['不能。维生素B驱蚊的谣言在网络上盛传，但实际已被科学实验证明毫无作用。类似的偏方、谣言还有很多，如超声波驱蚊、大蒜驱蚊，实际都没什么效用。最有效的驱蚊防蚊还是纱窗、蚊帐等物理方式+驱蚊液。如果是室外（如别墅花园、草坪），则可以考虑专业治理，包括药液的空间喷洒、滞留喷洒、植物绿篱处理、孑孓灭杀等。'],
                fuget_id: '405',
                img_list: []
              },
              {
                question: '家里有宝宝/宠物，是不是不能用驱蚊液，蚊香等产品？',
                answer: ['大部分的驱蚊液、蚊香含有的有效成分是拟除虫菊酯，家里如果有宝宝、宠物等敏感群体，建议在使用时将其隔离，等灭杀完后通风一段时间再将其带回室内。尤其是猫，无法代谢菊酯类药物，大量接触该有效成分会引起休克、中毒甚至死亡。用在身体上的驱蚊产品也要谨慎选择，美国儿科学会不建议2个月以下的宝宝使用化学驱蚊产品。儿童使用含避蚊胺的驱蚊产品时，避蚊胺浓度应该低于30%；3岁以下的小朋友不能使用含有柠檬桉叶油的驱蚊产品。'],
                fuget_id: '406',
                img_list: []
              },
            ]
          },
          {
            id: 9,
            questions: [
              {
                question: '怎么判断是被臭虫咬的？被臭虫咬了怎么办？',
                answer: ['臭虫主要出现在床的区域，因此手臂、颈背等裸露处容易被咬。臭虫叮咬会留下红肿痕迹，被咬处会起丘。严重时，这些红疹会连成串。被咬后会有灼烧的疼痛感，同时伴随瘙痒。被臭虫咬后应用抗菌肥皂清洗被咬处并及时就医。臭虫是一种较难处理的害虫，发现后应尽快请专业人士进行治理，并对床褥、被套等物品进行高温清洗消毒；地毯等织物进行吸尘处理。'],
                fuget_id: '417',
                img_list: ['notitle-1.jpg']
              },
              {
                question: '换了床垫和床上用品，还会有臭虫吗？',
                answer: ['家庭中，臭虫确实最有可能出现在床垫上，因此又被称为床虱，但臭虫的栖息地远不止这么一个区域。和床邻近的床头柜、床头板、一些木制缝隙、沙发、地毯等都可能隐藏着它们的身影。臭虫也容易在公共环境中随人携带传播，像国际航空、电影院、医院等。如果发现了臭虫，建议尽快请专业人士进行全面治理，以绝后患。'],
                fuget_id: '418',
                img_list: []
              },
              {
                question: '为什么臭虫难杀？',
                answer: ['在过去与臭虫的对抗中，人们肆意地使用各类杀虫剂，甚至是高毒农药来对付它们，导致现在许多臭虫产生抗药性，使根除工作愈发困难。千禧年来，全球臭虫有卷土重来的趋势，尤其是像美国一些地区，臭虫泛滥成灾。随着人们生活水平提高，国际交流也日益频繁，臭虫便也搭便车传播至各地。'],
                fuget_id: '419',
                img_list: []
              }
            ]
          },
          {
            id: 10,
            questions: [
              {
                question: '怎么判断是被蜱革螨咬了？有什么症状？',
                answer: ['蜱虫会试图钻进皮肤叮咬吸血，有时会看到它半边身体露在外面。被咬处发红，从内到外由深变浅。后期叮咬处若呈现似靶眼形状，则可能该蜱虫携带了莱姆病。被叮咬后会感觉到瘙痒和灼热感。发烧、头痛、疲劳是莱姆病的早期症状。若有类似症状，经检测未发现虫体时应及时去医院确诊医治。'],
                fuget_id: '432',
                img_list: ['1-21.jpg', '2-18.jpg']
              },
              {
                question: '怎么判断被革螨咬了？有什么症状？',
                answer: ['若被革螨叮咬，被咬处则出现红色圆形水肿性丘疹、水泡，疹块直径0.5～1cm，并伴有奇痒。革螨通常在动物饲养室、鸡窝、面粉厂、纱厂及野外场所等处活动并侵袭人群，主要叮咬部位多在腰部腋窝、腹股沟等处。若有类似症状，经检测未发现虫体时应及时去医院确诊医治。'],
                fuget_id: '433',
                img_list: ['3-19.jpg']
              },
              {
                question: '螨虫（尘螨）可以去除吗？',
                answer: ['虫虫拜拜目前暂未提供尘螨治理服务。虽然尘螨是几乎所有家庭都存在的问题，但尘螨的滋生跟空气环境十分紧密。一次性服务可以去除尘螨，但持效有限，这对用户来说是一件得不偿失的事情。尘螨的防治关键还在于日常的清洁，尤其是吸尘，以及定期对床单衣物进行高温清洗（&gt;60摄氏度）。'],
                fuget_id: '434',
                img_list: []
              },{
                question: '被蜱虫/革螨咬了怎么办？',
                answer: ['被蜱虫叮咬，切勿擅自用手指将其捏碎或将其硬拽下来，这样倒钩很容易留在皮肤里，里面的神经毒素会引起皮肤继发感染。应小心用镊子等工具夹住其口器小心拔出，若无法自行处理，应及时去医院就诊。革螨叮咬后主要工作是祛痒，尽可能不要去抓挠伤口，尽快去医院就诊，使用正确的抗过敏药膏。除此以外应对家中进行全面清洁和除虫处理。'],
                fuget_id: '435',
                img_list: []
              }
            ]
          },
          {
            id: 11,
            questions: [
              {
                question: '衣鱼长相恐怖，会咬人吗？',
                answer: ['衣鱼有咀嚼式的口器，但其实并不咬人或因此传播疾病，但它可能会引发敏感人群的过敏，尤其是在书房这类场所。衣鱼更多的危害在于破坏藏书、衣物等财物，因而又被称为书虫、衣虫或书蠹。'],
                fuget_id: '445',
                img_list: ['1-42.jpg']
              },
              {
                question: '藏书发现衣鱼，不舍得对书喷药，应该怎么处理？',
                answer: ['衣鱼平时喜欢在阴暗的缝隙活动，虽然衣鱼食性广泛，也包括纸张，但对其更具吸引力的是书籍装订使用的浆糊、胶水等富含蛋白、糖类的物质，对书籍的危害更多集中在书脊、封皮上。虫虫拜拜的服务主要针对的是衣鱼的主要藏身处，主要集中在踢脚线、书柜、书架的缝隙等，而书籍则建议将其取下对书脊、封皮处进行检查和打扫即可。'],
                fuget_id: '446',
                img_list: []
              }
            ]
          },
          {
            id: 12,
            questions: [
              {
                question: '厨房、厕所的虫子总是不断产生，除不尽这是为什么？',
                answer: ['很多家庭发现这些飞虫后，第一反应是赶紧拿喷雾罐喷，并对一些可见区域进行清洁，这会起到一定的效果，但治标不治本。厨卫飞虫的滋生地很多，从湿拖把到下水管道、地漏、甚至是马桶的密封处，都可能为它们提供温床；厨余垃圾、厕所污垢、管道里残留的毛发都能成为其食物。这些滋生点，有的十分隐蔽，难以直接触及，像地漏、马桶密封圈等，是装潢时就遗留下来的问题。'],
                fuget_id: '458',
                img_list: ['1-43.jpg']
              },
              {
                question: '家里保持得很干净/家住高楼，为什么还会有厨卫飞虫？',
                answer: ['厨卫飞虫并非是凭空从下水道、地漏这些地方长出来。它们主要还是从外界飞进来或被携带进来，并被臭水、污垢、腐烂有机物吸引驻扎下来。不要低估这些飞虫的入侵能力，它们完全可以飞很高，或阶梯式向上（甚至搭乘电梯）到达高楼层。平时购买的蔬菜水果等也可能携带虫子、虫卵，为其提供顺风车。'],
                fuget_id: '459',
                img_list: []
              },
              {
                question: '专业服务可以彻底根除厨卫飞虫吗？',
                answer: ['专业服务不只停留于表面，能更深入地解决问题。虫虫拜拜的厨卫飞虫治理服务可以100%灭杀已有的飞虫，但由于其滋生地条件导致药剂容易被冲刷稀释，停留时间有限，因此要使效果持久，还要用户的配合，如定期清理地漏里堵住的毛发、厨余垃圾密封等，服务工程师会根据现场情况给出实用的防护建议。'],
                fuget_id: '460',
                img_list: []
              }
            ]
          },
          {
            id: 13,
            questions: [
              {
                question: '衣柜日常防潮驱虫，用樟脑丸管用吗？',
                answer: ['虽然樟脑丸得名于樟脑，但常见樟脑丸的有效成分通常为对二氯苯。樟脑丸确实可以起到防虫的效果，但家庭仍应谨慎选择和使用。合成的樟脑丸毒性较大，一般用于工业品或农业品防蛀。美国HHS将对二氯苯认定为“合理推定为致癌物质”。家庭如使用了樟脑丸，衣物在取出使用前最好先进行晾晒。'],
                fuget_id: '472',
                img_list: []
              },
              {
                question: '衣橱里看到过一两只衣蛾/皮蠹，处理后没再看到新的，是否没问题了？',
                answer: ['织物害虫破坏力大的往往是它们的幼虫，以衣蛾为例，其成虫只负责繁殖不再进食。织物害虫繁殖能力也不可小觑，雌衣蛾一次可产下40-200枚卵，而产卵地又不容易寻找。若发现织物害虫踪迹，应将该区域所有衣物取出并高温清洗，并对橱柜内部角角落落进行检查，或请专业人员进行处理。'],
                fuget_id: '473',
                img_list: ['1-48.jpg']
              },
              {
                question: '织物害虫咬人吗？',
                answer: ['大部分织物害虫通常并不咬人，但像皮蠹也会以毛发为食，偶尔也会有织物害虫出现在床上，咬到人的案例。遇到这种情况，可及时用清水和肥皂清洁伤口，擦拭抗组胺药膏，以防过敏。'],
                fuget_id: '474',
                img_list: []
              }
            ]
          },
          {
            id: 14,
            questions: [
              {
                question: '家里为什么会有蛀木害虫？',
                answer: ['蛀木害虫通常是被携带进入或从外部入侵室内。装修的时候，一些木材可能就没有做好防护处理，携带进了蛀木害虫幼虫。此外大多蛀木害虫有趋光性，且有很强的飞行能力，随着绿化建设不断提升，其入侵室内的可能性也随之增高。蛀木害虫喜欢阴暗潮湿的生活环境，地下室、朝北房间、浸过水的区域更容易受侵害。'],
                fuget_id: '488',
                img_list: ['1-53.jpg']
              },
              {
                question: '家里发现有蛀木害虫怎么办，可以自己处理吗？',
                answer: ['蛀木害虫通常“为非作歹”的是它们的幼虫，如粉蠹会把虫卵产在木材里面。由于它们不是社会性昆虫，分布较为分散，且深藏在木材内部，因此处理起来并不容易。简单的喷药无法触及内部，通常处理后没多久又会复发，建议寻求专业治理。针对蛀木害虫，虫虫拜拜会通过滞留喷洒、涂刷、针孔灌注、薰闷等方法，直达它们的巢穴，彻底解决问题。'],
                fuget_id: '489',
                img_list: []
              },
              {
                question: '专业治理需要凿洞开孔？会对木结构带来破坏吗？',
                answer: ['大多数蛀木害虫等到发现危害时，往往木材外部已经有了孔洞。虫虫拜拜会借由这些孔洞，通过针孔灌注等方式深入治理，尽可能避免产生新的破坏。但有时一些蛀木害虫留下的孔洞是被它们废弃的，为了直达根源，我们需要重新钻孔进行灌注。虫虫拜拜选用的是3mm孔径的钻头，极力将破坏降到最小，实行微创处理。处理完后，所有的孔洞会用硅胶进行良好的封堵。'],
                fuget_id: '490',
                img_list: []
              }
            ]
          },
          {
            id: 15,
            questions: [
              {
                question: '被叮蛰害虫蜇伤的症状是什么？应该怎么处理？',
                answer: ['叮蛰害虫蛰伤后会产生尖锐的灼伤疼痛感，被叮蛰部位出现红肿。蜜蜂蜂针呈倒刺形，蜂针会留在皮肤处，被蛰处会起红疹，中心通常有颗瘀点。被蛰伤后勿用手挠，如有蜂针留在伤口，应小心将其整根拔出，可用肥皂水清洗，缓解症状，并尽快就医处理。如住处附近发现巢穴，应尽快请专业人员处理。'],
                fuget_id: '504',
                img_list: []
              },
              {
                question: '蜜蜂不是保护动物吗？应该如何处理？',
                answer: ['确实，蜜蜂其实并不算害虫，它对农业、环境有很重要的作用。而且蜜蜂不太会蜇人，若发起攻击通常是感受到了明显的威胁。但若被蜜蜂叮蛰仍是件痛苦的事，最好的办法是请专业人士安全地把它们转移到安全区域，切勿自行处理蜜蜂或其他蜂的蜂巢以保障安全。'],
                fuget_id: '505',
                img_list: []
              },
              {
                question: '蜜蜂蜇人后就会死亡吗？',
                answer: ['是的。蜜蜂的蜂针是倒刺形的，当它发起攻击后试图飞走时，不可避免地，蜂针会从其腹部撕裂下来，且连着它的部分腹部、消化道、肌肉、神经等组织，留在攻击对象皮肤内。胡蜂则不同，可多次发起攻击。'],
                fuget_id: '506',
                img_list: []
              }
            ]
          },
          {
            id: 16,
            questions: [
              {
                question: '潮湿害虫会咬人吗？',
                answer: ['潮湿害虫们基本都以真菌为食，因此不用担心会被它们咬进而导致疾病。但另一方面，潮湿害虫们与真菌相伴为生，如果大量出现，则意味着环境卫生状况出现了问题，真菌可能漫入空气（会有一股霉味），影响呼吸健康。因此建议发现后应及时处理。'],
                fuget_id: '516',
                img_list: ['1-65.jpg']
              },
              {
                question: '专业服务可以彻底根除潮湿害虫吗？',
                answer: ['很多潮湿害虫有很强的抗药性，一般的除虫药剂都不是很好处理，要彻底根治不是一件容易的事。专业服务不只停留于表面，能更深入地解决问题。虫虫拜拜的潮湿害虫治理服务会根据现场情况用酒精、粉剂、硼酸钠、结合药剂进行喷洒、刷施等处理，以彻底灭杀已有害虫。但如果要使效果持久，降低湿度保持干燥仍是关键，服务工程师会根据现场情况给出实用的防护建议。'],
                fuget_id: '517',
                img_list: []
              }
            ]
          },
          {
            id: 17,
            questions: [
              {
                question: '仓储害虫入侵有什么迹象？',
                answer: ['仓储害虫入侵的迹象表现为：粮食谷物等出现较多粉状碎屑；粮食储物被咬损破坏的痕迹；储物发霉，散发霉味；仓储害虫体积较大，易于辨认，如的确有仓储害虫为害，对粮食储物进行翻找，可找到相关虫体。'],
                fuget_id: '534',
                img_list: []
              },
              {
                question: '如果食物被仓储害虫感染，需要都扔掉吗？',
                answer: ['建议全部扔掉。一方面仓储害虫会污染破坏食物，使口感变差且可能携带病菌，另一方面滋生源的清理也有助于控制害虫进一步蔓延。', '如果储存量较大，譬如仓库，则建议及时将被危害区域筛选隔离，控制感染范围。'],
                fuget_id: '535',
                img_list: ['1-71.jpg']
              },
              {
                question: '已经把被污染的粮食物品扔掉了，但仍有印度谷螟等害虫，为什么？',
                answer: ['一些仓储害虫为有翅昆虫且具有趋光性，如印度谷螟，在傍晚的时候容易被灯光吸引进室内。此外，虽然危害区域集中于粮食储物，但其活动范围并不局限于特定某一区域，蛾类幼虫通常还会飞到一个远离食物源的隐藏的地方化蛹，成虫后交配时再将卵存放在适合的食品中。所以单把粮食物品扔掉并不能完全解决问题。'],
                fuget_id: '536',
                img_list: ['2-68.jpg']
              }
            ]
          },
          {
            id: 18,
            questions: [
              {
                question: '多足害虫会咬人吗？',
                answer: ['虽然长相不讨喜，但多足害虫大都不会主动攻击人。然而被触碰或受到惊吓时，不免也会攻击人。蜈蚣、马陆、蚰蜒都会分泌毒液。幸运的是，它们大部分都在室外。若偶然侵入室内，尤其是底楼住户、别墅住户，此时应及时将它们请出屋外，并最好对房屋边界做预防处理，以免其同伴再次入侵。'],
                fuget_id: '551',
                img_list: []
              },
              {
                question: '被蜈蚣/马陆/蚰蜒咬了有什么症状？应该怎么办？',
                answer: ['蚰蜒和马陆毒性较蜈蚣比较轻，被咬或接触处可能会引起红斑红疹，遇到这种情况应用大量肥皂水或清水清洗，勿用含酒精的风油精等擦拭。蜈蚣毒性较强，被咬处会留下明显的咬眼，会起红肿，有明显的疼痛感，甚至可能出现恶心、晕厥等现象。蜈蚣毒液呈酸性，应用肥皂水等碱性物质进行综合。被这些虫子攻击，简单处理后应及时就诊，向医生咨询合适的药膏进行治理。'],
                fuget_id: '552',
                img_list: ['1-36.jpg']
              },
              {
                question: '专业服务可以彻底根除多足害虫吗？',
                answer: ['很多多足害虫活动敏捷且比较分散，且生活场所大都在室外，要彻底根治不是一件容易的事。但家中若遭到此类多足害虫入侵，虫虫拜拜可通过灭杀家中已有的多足害虫，并在房屋边界如踢脚线、门槛、走廊等处设置化学防护带，进行边界预防，可以有效阻挡其同伴后续进入。'],
                fuget_id: '553',
                img_list: []
              }
            ]
          },
          {
            id: 20,
            questions: [
              {
                question: '花园害虫咬人吗？对人体是否有害？',
                answer: ['有些花园害虫在感受到威胁时会咬人，有些还会分泌毒液，譬如蜘蛛、隐翅虫。它们可通过叮咬、直接接触等方式引起中毒、过敏等症状。在户外时应尽量着长袖长裤，不在某一处长时间坐躺。如被攻击，可能会引起红斑红疹，应用大量肥皂水或清水清洗，简易处理后及时就诊，向医生咨询合适的治疗方案。'],
                fuget_id: '568',
                img_list: ['1-24.jpg']
              },
              {
                question: '外围绿化丰富，可以根除它们吗？',
                answer: ['室外环境多是开放式，复杂不可控，且很多害虫善飞行，要彻底根治非常困难。但虫虫拜拜可以灭杀家中已有的多足害虫，并在房屋边界如踢脚线、门槛、走廊等处设置化学防护带，进行边界预防，可有效阻挡其同伴后续进入。对于别墅、老洋房等用户，如有外围处理需要，也可以选择周期性服务，将它们的密度控制一定范围内。'],
                fuget_id: '569',
                img_list: []
              }
            ]
          },
        ]
      }
    },
    methods: {
      getHotQuesion(event) {
        this.$parent.getHotQuesion(event);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/hot_question.vue